import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'
// import { axiosInstance } from '@/api'

// Containers
const TheContainer = () => import('@/containers/TheContainer')



// ### Base Pages ###
const Home = () => import('@/vue/Home')
const Dashboard = () => import('@/vue/Dashboard')
const UserProfile = () => import('@/vue/pages/UserProfile')

// ### EV Survay ###
const Info = () => import('@/vue/ev/Info')
const Vehicle = () => import('@/vue/ev/Vehicle')
const Plan = () => import('@/vue/ev/Plan')
const OrganizationPlan = () => import('@/vue/ev/OrganizationPlan')
const OrganizationVehicle = () => import('@/vue/ev/OrganizationVehicle')

// ### CCTV Gateway ###
// const CCTV = () => import('@/vue/cctv/CCTV')
// const Robot = () => import('@/vue/cctv/Robot')
// const NVR = () => import('@/vue/cctv/NVR')
// const Stream = () => import('@/vue/cctv/Stream')

// Views - Pages
const Page404 = () => import('@/vue/pages/Page404')
const Page500 = () => import('@/vue/pages/Page500')
const Login = () => import('@/vue/pages/Login')
const Register = () => import('@/vue/pages/Register')
const Callback = () => import('@/vue/pages/Callback')
const Redirect = () => import('@/vue/pages/Redirect')

// MECAs
// const UserProfile = () => import('@/views/mecas/UserProfile')
// const UserBill = () => import('@/views/mecas/UserBill')


// const Workspaces = () => import('@/views/mecas/Workspaces')
// const WorkspaceInformation = () => import('@/views/mecas/WorkspaceInformation')
// const WorkspaceMembers = () => import('@/views/mecas/WorkspaceMembers')

// const Projects = () => import('@/views/mecas/Projects')
// const ProjectInformation = () => import('@/views/mecas/ProjectInformation')
// const ProjectMembers = () => import('@/views/mecas/ProjectMembers')
// const ProjectQuota = () => import('@/views/mecas/ProjectQuota')
// const ProjectContainerResource = () => import('@/views/mecas/ProjectContainerResource')
// const ProjectPortset = () => import('@/views/mecas/ProjectPortset')

// const ClusterUser = () => import('@/views/mecas/ClusterUser')
// const ClusterWorkspace = () => import('@/views/mecas/ClusterWorkspace')
// const ClusterProject = () => import('@/views/mecas/ClusterProject')
// const ClusterQuota = () => import('@/views/mecas/ClusterQuota')
// const ClusterLimitRange = () => import('@/views/mecas/ClusterLimitRange')
// const ClusterPortset = () => import('@/views/mecas/ClusterPortset')
// const ClusterBillFactor = () => import('@/views/mecas/ClusterBillFactor')
// const ClusterBill = () => import('@/views/mecas/ClusterBill')
// const ClusterBillLegacy = () => import('@/views/mecas/ClusterBillLegacy')
// const ClusterBillCustom = () => import('@/views/mecas/ClusterBillCustom')

// Views
const Colors = () => import('@/views/theme/Colors')
const Typography = () => import('@/views/theme/Typography')

const Charts = () => import('@/views/charts/Charts')
const Widgets = () => import('@/views/widgets/Widgets')

// Views - Auths
// RequiredLogin & RequiredAdmin are use router-guard to verify permission
const RequiredLogin = () => import('@/views/auths/RequiredLogin')
const RequiredAdmin = () => import('@/views/auths/RequiredAdmin')

// Views - Components
const Cards = () => import('@/views/base/Cards')
const Forms = () => import('@/views/base/Forms')
const Switches = () => import('@/views/base/Switches')
const Tables = () => import('@/views/base/Tables')
const Tabs = () => import('@/views/base/Tabs')
const Breadcrumbs = () => import('@/views/base/Breadcrumbs')
const Carousels = () => import('@/views/base/Carousels')
const Collapses = () => import('@/views/base/Collapses')
const Jumbotrons = () => import('@/views/base/Jumbotrons')
const ListGroups = () => import('@/views/base/ListGroups')
const Navs = () => import('@/views/base/Navs')
const Navbars = () => import('@/views/base/Navbars')
const Paginations = () => import('@/views/base/Paginations')
const Popovers = () => import('@/views/base/Popovers')
const ProgressBars = () => import('@/views/base/ProgressBars')
const Tooltips = () => import('@/views/base/Tooltips')

// Views - Buttons
const StandardButtons = () => import('@/views/buttons/StandardButtons')
const ButtonGroups = () => import('@/views/buttons/ButtonGroups')
const Dropdowns = () => import('@/views/buttons/Dropdowns')
const BrandButtons = () => import('@/views/buttons/BrandButtons')

// Views - Icons
const CoreUIIcons = () => import('@/views/icons/CoreUIIcons')
const Brands = () => import('@/views/icons/Brands')
const Flags = () => import('@/views/icons/Flags')

// Views - Notifications
const Alerts = () => import('@/views/notifications/Alerts')
const Badges = () => import('@/views/notifications/Badges')
const Modals = () => import('@/views/notifications/Modals')



// Users
const Users = () => import('@/views/users/Users')
const User = () => import('@/views/users/User')

Vue.use(Router)

const router = new Router({
  // mode: 'hash', Core-UI use default mode: 'hash'
  // But keycloak-js onLoad: 'check-sso' require mode: 'history'
  mode: 'history',
  linkActiveClass: 'active',
  scrollBehavior: () => ({ y: 0 }),
  routes: configRoutes()
})

function configRoutes () {
  return [
    {
      path: '/',
      redirect: '/home',
      // name: 'Site',
      component: TheContainer,
      children: [
        {
          path: 'home',
          name: 'Home',
          component: Home,
        },
        {
          path: 'dashboard',
          name: 'Dashboard',
          component: Dashboard,
        },
        {
          path: 'profile',
          name: 'User Profile',
          component: UserProfile,
        },
        {
          path: 'document',
          name: 'Document',
          beforeEnter(to, from, next) {
            window.location.href = "https://docs.google.com/document/d/1TSN9b1rXoc50NnHkPpL8LEJNBoKGVffK0IK7miMuQf0/edit?usp=sharing";
          }
        },
        {
          path: 'info',
          name: 'Info',
          component: Info,
          meta: { requiresUnsuspend: true }
        },
        {
          path: 'plan',
          name: 'Plan',
          component: Plan,
          meta: { requiresUnsuspend: true }
        },
        {
          path: 'vehicle',
          name: 'Vehicle',
          component: Vehicle,
          meta: { requiresUnsuspend: true }
        },
        {
          path: 'organization-plan',
          name: 'Plan Organization',
          component: OrganizationPlan,
          meta: { requiresUnsuspend: true }
        },
        {
          path: 'organization-vehicle',
          name: 'Vehicle Organization',
          component: OrganizationVehicle,
          meta: { requiresUnsuspend: true }
        },
        // {
        //   path: 'cctvs',
        //   name: 'CCTVs',
        //   component: CCTV,
        //   meta: { 
        //     requiresAdmin: true 
        //   }
        // },
        // {
        //   path: 'robots',
        //   name: 'Robots',
        //   component: Robot,
        //   meta: { 
        //     requiresAdmin: true 
        //   }
        // },
        // {
        //   path: 'project',
        //   name: 'Project',
        //   redirect: '/projects',
        //   component: {
        //     render (c) { return c('router-view') }
        //   },
        //   children: [
        //     {
        //       path: '/projects',
        //       name: 'Projects',
        //       component: Projects,
        //       meta: { requiresUnsuspend: true }
        //     },
        //     {
        //       path: ':name/information',
        //       name: 'Project Information',
        //       component: ProjectInformation,
        //       meta: { requiresUnsuspend: true }
        //     },
        //     {
        //       path: ':name/members',
        //       name: 'Project Members',
        //       component: ProjectMembers,
        //       meta: { requiresUnsuspend: true }
        //     },
        //     {
        //       path: ':name/quota',
        //       name: 'Quota',
        //       component: ProjectQuota,
        //       meta: { requiresUnsuspend: true }
        //     },
        //     // {
        //     //   path: ':name/quota2',
        //     //   name: 'Project Quota2',
        //     //   component: ProjectQuota2,
        //     //   meta: { requiresUnsuspend: true }
        //     // },
        //     {
        //       path: ':name/default-resource',
        //       name: 'Default Container Resource',
        //       component: ProjectContainerResource,
        //       meta: { requiresUnsuspend: true }
        //     },
        //     {
        //       path: ':name/portset',
        //       name: 'Portset',
        //       component: ProjectPortset,
        //       meta: { requiresUnsuspend: true }
        //     },
        //   ]
        // },
        {
          path: 'auths',
          redirect: '/auths/required-login',
          name: 'Authentication Pages',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'required-login',
              name: 'Required Login',
              component: RequiredLogin,
              meta: { requiresUnsuspend: true }
            },
            {
              path: 'required-admin',
              name: 'Required Admin',
              component: RequiredAdmin,
              meta: { requiresAdmin: true }
            }
          ]
        },
        {
          path: 'theme',
          redirect: '/theme/colors',
          name: 'Theme',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'colors',
              name: 'Colors',
              component: Colors
            },
            {
              path: 'typography',
              name: 'Typography',
              component: Typography
            }
          ]
        },
        {
          path: 'charts',
          name: 'Charts',
          component: Charts
        },
        {
          path: 'widgets',
          name: 'Widgets',
          component: Widgets
        },
        {
          path: 'users',
          meta: {
            label: 'Users'
          },
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: '',
              name: 'Users',
              component: Users
            },
            {
              path: ':id',
              meta: {
                label: 'User Details'
              },
              name: 'User',
              component: User
            }
          ]
        },
        {
          path: 'base',
          redirect: '/base/cards',
          name: 'Base',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'cards',
              name: 'Cards',
              component: Cards
            },
            {
              path: 'forms',
              name: 'Forms',
              component: Forms
            },
            {
              path: 'switches',
              name: 'Switches',
              component: Switches
            },
            {
              path: 'tables',
              name: 'Tables',
              component: Tables
            },
            {
              path: 'tabs',
              name: 'Tabs',
              component: Tabs
            },
            {
              path: 'breadcrumbs',
              name: 'Breadcrumbs',
              component: Breadcrumbs
            },
            {
              path: 'carousels',
              name: 'Carousels',
              component: Carousels
            },
            {
              path: 'collapses',
              name: 'Collapses',
              component: Collapses
            },
            {
              path: 'jumbotrons',
              name: 'Jumbotrons',
              component: Jumbotrons
            },
            {
              path: 'list-groups',
              name: 'List Groups',
              component: ListGroups
            },
            {
              path: 'navs',
              name: 'Navs',
              component: Navs
            },
            {
              path: 'navbars',
              name: 'Navbars',
              component: Navbars
            },
            {
              path: 'paginations',
              name: 'Paginations',
              component: Paginations
            },
            {
              path: 'popovers',
              name: 'Popovers',
              component: Popovers
            },
            {
              path: 'progress-bars',
              name: 'Progress Bars',
              component: ProgressBars
            },
            {
              path: 'tooltips',
              name: 'Tooltips',
              component: Tooltips
            }
          ]
        },
        {
          path: 'buttons',
          redirect: '/buttons/standard-buttons',
          name: 'Buttons',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'standard-buttons',
              name: 'Standard Buttons',
              component: StandardButtons
            },
            {
              path: 'button-groups',
              name: 'Button Groups',
              component: ButtonGroups
            },
            {
              path: 'dropdowns',
              name: 'Dropdowns',
              component: Dropdowns
            },
            {
              path: 'brand-buttons',
              name: 'Brand Buttons',
              component: BrandButtons
            }
          ]
        },
        {
          path: 'icons',
          redirect: '/icons/coreui-icons',
          name: 'CoreUI Icons',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'coreui-icons',
              name: 'Icons library',
              component: CoreUIIcons
            },
            {
              path: 'brands',
              name: 'Brands',
              component: Brands
            },
            {
              path: 'flags',
              name: 'Flags',
              component: Flags
            }
          ]
        },
        {
          path: 'notifications',
          redirect: '/notifications/alerts',
          name: 'Notifications',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: 'alerts',
              name: 'Alerts',
              component: Alerts
            },
            {
              path: 'badges',
              name: 'Badges',
              component: Badges
            },
            {
              path: 'modals',
              name: 'Modals',
              component: Modals
            }
          ]
        }
      ]
    },
    {
      path: '/pages',
      redirect: '/pages/404',
      name: 'Pages',
      component: {
        render (c) { return c('router-view') }
      },
      children: [
        {
          path: '404',
          name: 'Page404',
          // ### Force redirect to /home
          component: Page404,
          // beforeEnter(to, from, next) {
          //   window.location.pathname = "/home"
          // }
        },
        {
          path: '500',
          name: 'Page500',
          component: Page500,
          // ### Force redirect to /home
          // beforeEnter(to, from, next) {
          //   window.location.pathname = "/home"
          // }
        },
        {
          path: 'login',
          name: 'Login',
          component: Login
        },
        {
          path: 'register',
          name: 'Register',
          component: Register
        },
        {
          path: 'callback',
          name: 'Callback',
          component: Callback
        },
        {
          path: 'redirect',
          name: 'Redirect',
          component: Redirect
        },
      ]
    }
  ]
}

// ##### Route Guard Original #####
// router.beforeEach((to, from, next) => {
//   if (to.matched.some(record => record.meta.requiresAuth)) {
//     if (!store.state.isAuthenticated) {
//       next({
//         // path: '/'
//         name: 'Page500'
//       })
//     } else {
//       next()
//     }
//   }
//   next()
// })

// ### Router Guard Option 1: long if
// router.beforeEach((to, from, next) => {
//   if (to.matched.some(record => (record.meta.requiresAdmin !== undefined || record.meta.requiresUnsuspend !== undefinded))) {
//     if (to.matched.some(record => record.meta.requiresAdmin)) {
//       console.log('Router Guard: Administrator')
//       if (!store.state.user.isAdministrator) {
//         next({
//           name: 'Page500'
//         })
//       } else {
//         next()
//       }
//     }
//     if (to.matched.some(record => record.meta.requiresUnsuspend)) {
//       console.log('Router Guard: Unsuspend')
//       console.log(store.state.user.isSuspended)
//       let i = 0
//       let interval = setInterval(() => {
//         if (store.state.user.isSuspended !== undefined || i > 10) {
//           clearInterval( interval )
//           console.log('Router Guard clear interval ')
//           if(store.state.user.isSuspended !== false) {
//             console.log('Router Guard Reject')
//             next({
//               name: 'Home'
//             })
//           } else {
//             console.log('Router Guard Accept')
//             next()
//           }
//         }
//         console.log('Router Guard Check #',i)
//         i++
//       }, 200)
//     }
//   } else {
//     next()
//   }
// })

// ### Router Guard Option 2: short if
router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAdmin)) {
    console.log('Router Guard: Administrator')
    if (!store.state.user.isAdministrator) {
      next({ name: 'Page500' })
    } else {
      next()
    }
  } else if (to.matched.some(record => record.meta.requiresUnsuspend)) {
    console.log('Router Guard: Unsuspend')
    console.log(store.state.user.isSuspended)
    let i = 0
    let interval = setInterval(() => {
      if (store.state.user.isSuspended !== undefined || i > 10) {
        clearInterval( interval )
        console.log('Router Guard clear interval ')
        if(store.state.user.isSuspended === true) {
          console.log('Router Guard Reject')
          next({ name: 'User Profile'})
        } else if(store.state.user.isSuspended === false) {
          console.log('Router Guard Accept')
          next()
        } else {
          console.log('Router Guard Reject The pending user')
          next({ name: 'User Profile'})
        }
      }
      console.log('Router Guard Check #',i)
      i++
    }, 200)
  } else {
    console.log('No Router Guard')
    next()
  }
})

export default router
